module.exports = __webpack_public_path__ + "static/profiel_foto-b843bf466f2b52838ff35581dbd0a21a.jpg";